import { render, staticRenderFns } from "./lp-avatar.vue?vue&type=template&id=ba3642d2&scoped=true&"
import script from "./lp-avatar.vue?vue&type=script&lang=js&"
export * from "./lp-avatar.vue?vue&type=script&lang=js&"
import style0 from "./lp-avatar.vue?vue&type=style&index=0&id=ba3642d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3642d2",
  null
  
)

export default component.exports